import { createActionTypes } from "@helpers/redux-helpers";

export const getLivestreamMessagesActionTypes = createActionTypes(
  "livestreams/get/messages",
);
